import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';

// Layouts
import AdminLayout from './layouts/AdminLayout';
import TherapistLayout from './layouts/TherapistLayout';
import PatientLayout from './layouts/PatientLayout';

// Admin Pages
import AdminDashboard from './pages/admin/AdminDashboard';
import ComplianceConsole from './pages/admin/ComplianceConsole';
import PredictiveInsights from './pages/admin/PredictiveInsights';
import SupplyDemand from './pages/admin/SupplyDemand';
import AIAgentOversight from './pages/admin/AIAgentOversight';
import AdminReports from './pages/admin/AdminReports';
import AdminSettings from './pages/admin/AdminSettings';

// Therapist Pages
import TherapistDashboard from './pages/therapist/TherapistDashboard';
import PatientDetail from './pages/therapist/PatientDetail';
import TherapistChat from './pages/therapist/TherapistChat';
import TherapistSettings from './pages/therapist/TherapistSettings';

// Patient Pages
import PatientDashboard from './pages/patient/PatientDashboard';
import PatientProgress from './pages/patient/PatientProgress';
import PatientCompanion from './pages/patient/PatientCompanion';
import ReminderSettings from './pages/patient/ReminderSettings';

// Landing Page
import LandingPage from './pages/LandingPage';

function App() {
  return (
    <Router>
      <Routes>
        {/* Landing Page */}
        <Route path="/" element={<LandingPage />} />
        
        {/* Admin Routes */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="compliance" element={<ComplianceConsole />} />
          <Route path="predictive" element={<PredictiveInsights />} />
          <Route path="supply-demand" element={<SupplyDemand />} />
          <Route path="ai-oversight" element={<AIAgentOversight />} />
          <Route path="reports" element={<AdminReports />} />
          <Route path="settings" element={<AdminSettings />} />
        </Route>
        
        {/* Therapist Routes */}
        <Route path="/therapist" element={<TherapistLayout />}>
          <Route index element={<TherapistDashboard />} />
          <Route path="patient/:id" element={<PatientDetail />} />
          <Route path="chat" element={<TherapistChat />} />
          <Route path="settings" element={<TherapistSettings />} />
        </Route>
        
        {/* Patient Routes */}
        <Route path="/patient" element={<PatientLayout />}>
          <Route index element={<PatientDashboard />} />
          <Route path="progress" element={<PatientProgress />} />
          <Route path="companion" element={<PatientCompanion />} />
          <Route path="reminders" element={<ReminderSettings />} />
        </Route>
        
        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster position="top-right" richColors />
    </Router>
  );
}

export default App;
